import { useScrollAnimation } from "../../../hooks/useScrollAnimation";
import { processSteps } from "../../../mocks/homeData";

export default function Process() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <section id="process" className="bg-white py-16 md:py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8" ref={ref}>
        <div className="text-center mb-12 md:mb-16">
          <div
            className={`inline-block w-12 h-1 rounded-full bg-copper mb-4 ${
              isVisible ? "animate-fade-up" : "opacity-0"
            }`}
          />
          <h2
            className={`font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-navy mb-4 ${
              isVisible ? "animate-fade-up" : "opacity-0"
            }`}
            style={{ animationDelay: "0.1s" }}
          >
            Fikrinizden Teslimata Kadar Yanınızdayız
          </h2>
          <p
            className={`font-body text-base md:text-lg text-gray-600 max-w-2xl mx-auto ${
              isVisible ? "animate-fade-up" : "opacity-0"
            }`}
            style={{ animationDelay: "0.2s" }}
          >
            5 adımlık sistematik sürecimizle projelerinizi zamanında ve bütçe dahilinde teslim ediyoruz.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-[60px] left-[10%] right-[10%] h-0.5">
            <div
              className={`h-full bg-gray-300 ${
                isVisible ? "animate-[scaleX_1s_ease-out_forwards]" : ""
              }`}
              style={{ transformOrigin: "left", animationDelay: "0.3s" }}
            />
            <div
              className={`absolute inset-0 h-full bg-copper origin-left ${
                isVisible ? "animate-[scaleX_1.5s_ease-out_forwards]" : "scale-x-0"
              }`}
              style={{ animationDelay: "0.5s" }}
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-6">
            {processSteps.map((step, index) => (
              <div
                key={step.step}
                className={`relative flex flex-col items-center text-center ${
                  isVisible ? "animate-fade-up" : "opacity-0"
                }`}
                style={{ animationDelay: `${0.3 + index * 0.15}s` }}
              >
                <div className="relative mb-4 md:mb-5">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white border-[3px] border-copper flex items-center justify-center shadow-md z-10 relative">
                    <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center text-copper">
                      <i className={`${step.icon} text-2xl md:text-3xl`} />
                    </div>
                  </div>
                  <div className="absolute -top-2 -right-2 w-7 h-7 md:w-8 md:h-8 rounded-full bg-copper text-white font-heading font-bold text-xs md:text-sm flex items-center justify-center">
                    {step.step}
                  </div>
                </div>

                <h3 className="font-heading font-bold text-base md:text-lg text-navy mb-2">
                  {step.title}
                </h3>
                <p className="font-body text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}